import React, { useContext } from 'react';
import { navigate } from '@reach/router';
import logo from '../../assets/logo.jpg';
import { StyledLogoWrapper } from '../Styled';
import { EditToolContext } from '../../contexts/editToolContext';
import { EXEMPLARS } from '../../constants';
import { getDefaultStage } from '../../utils/storage';

export const Logo = (): JSX.Element => {
  const { handleLeavePage } = useContext(EditToolContext);

  const toUrl = `/${EXEMPLARS}/${getDefaultStage()}`;

  return (
    <StyledLogoWrapper
      data-testid="logo"
      onClick={e => handleLeavePage(() => navigate(toUrl), false, e)}
      to={toUrl}
      aria-label="navigate to the main page"
    >
      <img src={logo as string} alt="Logo" />
    </StyledLogoWrapper>
  );
};
